var React = require('react');

function IconPenCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512.5 67.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM391.4 722.9h-86.5v-86.5L560 381.3l86.5 86.5-255.1 255.1zm321.9-322l-42.2 42.2-86.5-86.5 42.2-42.2c9-9 23.5-9 32.5 0l54 54c9 9 9 23.5 0 32.5z"}));
}

IconPenCircleSolid.displayName = "IconPenCircleSolid";

IconPenCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPenCircleSolid;

IconPenCircleSolid.default = IconPenCircleSolid;
